export default __webpack_public_path__ + "static/media/justificativas.28a02327.svg";